import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyles } from './DetailProductListing.styles'
import { Grid, Link, Typography } from '@mui/material'
import {
  ShortenedNameV2,
  SelectedCloudIcon,
  LoadingTypes,
  isLoading as Loading,
  useCurrentCloudProvider,
  useAccountId,
  actionTypeWrapper,
  ScrollToFieldError,
  SnackBar,
} from '@labrav/common'
import {
  faArrowLeft,
  faClone,
  faPen,
  faSave,
  faArrowUpRightFromSquare,
  faHourglassStart,
  faLaptopSlash,
  faDeleteRight,
  faLaptop,
  faSync,
  faListCheck,
} from '@fortawesome/pro-regular-svg-icons'
import { useNavigate, useParams } from 'react-router-dom'
import {
  BoxV2,
  ButtonV2,
  ColumnActionWithMenuColors,
  ColumnActionWithMenuV2,
  ColumnMenuOption,
  LabraToolTipV2,
  MainTabsV2,
  ModalConfirmV2,
  ModalSizeVariants,
  StatusBar,
  StatusBarColors,
  StatusListing,
} from '@labrav/react-components'
import { useDispatch, useSelector } from '../../store'
import {
  FlyoutProductSections,
  StatusListingResObj,
  StatusListingItem,
  FlyoutProductAddEditSectionName,
} from '../../types/addEditProduct'
import { useCallback, useEffect, useState } from 'react'
import { useSyncFlyoutRouteParams } from '../../common/utils/hooks/useSyncFlyoutRouteParams'
import {
  flyoutProductSyncWithAWS,
  getProductDetail,
  updateFlyoutProduct,
} from '../../modules/addEditProduct/action'
import { ProductStatus } from '../../modules/productsListing/types'
import FlyoutProductValidationSchema from '../../common/utils/FlyoutProductValidationSchema'
import { Form, Formik, FormikProps } from 'formik'
import { getStatusListingData } from '../../common/utils/productEditUtil'
import { isEmpty } from 'lodash'
import { FlyOutNotificationSection } from '../AddEditProduct/AddEditProductListing/FlyOutNotificationSection/FlyOutNotificationSection'
import { FlyoutLandingPageSection } from '../AddEditProduct/AddEditProductListing/FlyoutLandingPageSection/FlyoutLandingPageSection'
import { FlyOutProductDetails } from '../AddEditProduct/AddEditProductListing/FlyOutProductDetailsSection/FlyOutProductDetailsSection'
import {
  AwsDimensionCategories,
  FlyoutProductDimensionsSection,
  initialAwsDimensionCategories,
} from '../AddEditProduct/AddEditProductListing/FlyoutProductDimensionsSection/FlyoutProductDimensionsSection'
import clsx from 'clsx'
import { FooterV2 } from '../../common/components/FooterV2/FooterV2'
import { fetchAwsDimensionsCategoriesList } from '../../common/api'
import { CellWithLinkText } from '../../common/components/CellWithLinkText'
import {
  getStatusBarDetails,
  productDetailDate,
  validateProductCreationFlow,
} from '../../common/utils/productCreationUtil'
import {
  deleteProductListingData,
  publishProductListingData,
  setSelectedProductOnListing,
  unpublishProductListingData,
} from '../../modules/productsListing/action'
import { buyerRegistrationPagePreviewMessage } from '../../common/utils/messagesConstants'
import {
  BuyerRegistrationPreviewButton,
  BuyerRegistrationPreviewModal,
} from '../../common/components/BuyerRegistrationPreviewComponents/BuyerRegistrationPreviewComponents'
const listingEditTooltip = 'Click on “Edit listing” to start editing.'

export const DetailProductListing = () => {
  useSyncFlyoutRouteParams()

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { productId = '', accountId: routeAccountId } = useParams<{
    productId?: string
    cloud?: string
    accountId?: string
  }>()
  const defaultAccountId = useAccountId({ product: 'flyout' })
  const currentAccountId = routeAccountId || defaultAccountId

  const selectedCloudTypeProductListing = useCurrentCloudProvider()

  const flyoutProductDetailForm = useSelector<FlyoutProductSections>(
    state => state.flyoutProductInCreation.currentProductDetail.productForm
  )
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const { isLoading } = useSelector<{
    isLoading: boolean
  }>(state => ({
    isLoading: Loading(state.loading)(
      LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL
    ),
  }))

  const { isLoading: isLoadingSyncWithCloud } = useSelector<{
    isLoading: boolean
  }>(state => ({
    isLoading: Loading(state.loading)(LoadingTypes.PRODUCT_SYNC_WITH_CLOUD),
  }))

  const status = useSelector<string>(
    state => state.flyoutProductInCreation.currentProductDetail.status
  )
  const isEditEnable = useSelector<boolean>(
    state => !!state.flyoutProductInCreation.currentProductDetail.edit
  )
  const marketplaceUrl = useSelector<string>(
    state =>
      state.flyoutProductInCreation.currentProductDetail?.marketplaceUrl || ''
  )
  const auditJson = useSelector<StatusListingResObj>(
    state => state.flyoutProductInCreation.currentProductDetail.auditJson
  )
  const awsChangeSetStatus = useSelector<string>(
    state =>
      state.flyoutProductInCreation.currentProductDetail.awsChangeSetStatus ||
      ''
  )

  const failureErrorMessage = useSelector<string>(
    state => state.flyoutProductInCreation.currentProductDetail.error || ''
  )

  const updatedAt = useSelector<string>(
    state => state.flyoutProductInCreation.currentProductDetail?.updatedAt || ''
  )
  const { fullDateTime: updatedAtValue } = updatedAt
    ? productDetailDate(updatedAt)
    : { fullDateTime: '' }

  const isChangeSetFailed =
    awsChangeSetStatus === 'FAILED' || !isEmpty(failureErrorMessage)
  const [statuses, setStatusListing] = useState<StatusListingItem[]>([])
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [detailView, setDetailView] = useState(true)
  const [openUnpublishModal, setOpenUnpublishModal] = useState(false)
  const [openPublishModal, setOpenPublishModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)

  const [awsDimensionCategories, setAwsDimensionCategoriesList] =
    useState<AwsDimensionCategories>(initialAwsDimensionCategories)

  const { classes } = useStyles({ status, detailView, isEditEnable })
  const productName = useSelector<string>(
    state => state.flyoutProductInCreation.currentProductDetail.productName
  )

  const handlePublish = async () => {
    await dispatch(
      publishProductListingData({
        partnerId: currentAccountId || '',
        productId,
        alertMessages: {
          success: `"${productName}" ${status} listing published succesfully`,
          error: `"${productName}" ${status} listing could not be published`,
        },
      })
    )
    await dispatch(
      getProductDetail({
        partnerId: currentAccountId || '',
        productId,
      })
    )
    setOpenPublishModal(false)
  }
  const handlePublishDecline = () => {
    setOpenPublishModal(false)
  }
  const handleDelete = async () => {
    try {
      await dispatch(
        deleteProductListingData({
          partnerId: currentAccountId || '',
          productId,
          alertMessages: {
            success: `"${productName}" ${status} listing deleted succesfully`,
            error: `"${productName}" ${status} listing could not be deleted`,
          },
        })
      )
      navigate('/flyout/products-listing')
    } catch {
      // stay within the same page and don't navigate to product-listing page if product is failed to be deleted
    }

    setOpenDeleteModal(false)
  }
  const handleDeleteDecline = () => {
    setOpenDeleteModal(false)
  }
  const handleUnpublish = async () => {
    await dispatch(
      unpublishProductListingData({
        partnerId: currentAccountId || '',
        productId,
        alertMessages: {
          success: `"${productName}" ${status} listing unpublished succesfully`,
          error: `"${productName}" ${status} listing could not be unpublished`,
        },
      })
    )
    await dispatch(
      getProductDetail({
        partnerId: currentAccountId || '',
        productId,
      })
    )
    setOpenUnpublishModal(false)
  }
  const handleUnpublishDecline = () => {
    setOpenUnpublishModal(false)
  }
  const handleSelectOption = async (option: ColumnMenuOption) => {
    if (option.route) {
      if (['view-private-offers', 'view-revenue'].includes(option.key)) {
        await dispatch(
          actionTypeWrapper(
            selectedCloudTypeProductListing,
            setSelectedProductOnListing(productId)
          )
        )
      }

      navigate(option?.route)
    } else if (option.key === 'go-aws-marketplace') {
      const newWindow = window.open(
        marketplaceUrl,
        '_blank',
        'noopener, noreferrer'
      )
      if (newWindow) newWindow.opener = null
    } else if (option.key === 'unpublish-listing') {
      setOpenUnpublishModal(true)
    } else if (option.key === 'publish-listing') {
      setOpenPublishModal(true)
    } else if (option.key === 'delete-listing') {
      setOpenDeleteModal(true)
    }
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleDiscardChanges = useCallback(
    (formikProps: FormikProps<FlyoutProductSections>) => {
      formikProps.resetForm()
      setDetailView(true)
      setOpenModal(false)
    },
    [openModal]
  )

  const handleEditClick = () => {
    setDetailView(false)
  }

  const handleProductSync = async () => {
    if (currentAccountId) {
      await dispatch(
        flyoutProductSyncWithAWS({
          partnerId: currentAccountId,
          productId,
          productName,
        })
      )
    }
  }

  useEffect(() => {
    if (!isEmpty(auditJson)) {
      const statuses = getStatusListingData(auditJson, status)?.sort(
        (a, b) => a.sortOrder - b.sortOrder
      )
      setStatusListing(statuses)
    }
  }, [currentAccountId, productId, auditJson])

  useEffect(() => {
    fetchAwsDimensionsCategoriesList()
      .then(response => {
        const { usage_map, ...rest } = response.data
        setAwsDimensionCategoriesList({
          ...rest,
          usageMap: usage_map,
        })
      })
      .catch(error => {
        console.error('Failed to fetch list:', error)
      })
  }, [])

  useEffect(() => {
    if (currentAccountId && productId) {
      dispatch(
        getProductDetail({
          partnerId: currentAccountId,
          productId,
        })
      )
    }
  }, [currentAccountId, productId])

  const ProductDetailTabs = [
    {
      key: 'product-details',
      label: 'Product details',
      renderElement: (
        <FlyOutProductDetails
          productView
          detailView={detailView}
          detailViewTooltip={detailView ? listingEditTooltip : ''}
        />
      ),
    },
    {
      key: 'product-dimensions',
      label: 'Product dimensions',
      renderElement: (
        <FlyoutProductDimensionsSection
          awsDimensionCategoriesProps={awsDimensionCategories}
          productView
          detailView={detailView}
          detailViewTooltip={detailView ? listingEditTooltip : ''}
        />
      ),
    },
    {
      key: 'landing-page-details',
      label: 'Buyer registration page',
      renderElement: (
        <>
          <FlyoutLandingPageSection
            productView
            detailView={detailView}
            detailViewTooltip={detailView ? listingEditTooltip : ''}
          />
        </>
      ),
    },
    {
      key: 'notifications',
      label: 'Notifications',
      renderElement: (
        <>
          <FlyOutNotificationSection
            productView
            detailView={detailView}
            detailViewTooltip={detailView ? listingEditTooltip : ''}
          />
        </>
      ),
    },
  ]

  const options = [
    {
      label: 'Archive listing',
      route: '',
      key: 'archive-listing',
      borderBottom: true,
    },
    {
      label: 'View private offers',
      route: '/flyout/offers-authorizations/private-offers',
      disable: false,
      key: 'view-private-offers',
    },
    {
      label: 'View revenue',
      route: '/flyout/revenue',
      disable: false,
      key: 'view-revenue',
      borderBottom: true,
    },
    {
      label: (
        <>
          <CellWithLinkText
            linkText={'Go to AWS Marketplace listing page'}
            linkUrl={marketplaceUrl}
            linkUrlToText={false}
          />
        </>
      ),
      disable: isEmpty(marketplaceUrl),
      key: 'go-aws-marketplace',
    },
  ]

  const updateOptionsBasedOnStatus = (status: string): ColumnMenuOption[] =>
    options
      .map(option => {
        if (option.key === 'archive-listing') {
          switch (status) {
            case ProductStatus.PRODUCT_STATUS_PUBLIC:
              return {
                ...option,
                label: 'Unpublish listing',
                key: 'unpublish-listing',
              }
            case ProductStatus.PRODUCT_STATUS_RESTRICTED:
              return {
                ...option,
                label: 'Publish listing',
                key: 'publish-listing',
                disable: true,
                disabledTooltip:
                  'Please raise a ticket with Labra to publish restricted listing',
              }
            case ProductStatus.PRODUCT_STATUS_REJECTED:
              return {
                ...option,
                label: 'Publish listing',
                key: 'publish-listing',
              }
            case ProductStatus.PRODUCT_STATUS_AWS_TESTING:
              return {
                ...option,
                label: 'Withdraw listing request',
                key: 'withdraw-listing-request',
              }
            case ProductStatus.PRODUCT_STATUS_CREATION_FAILED:
              return {
                ...option,
                label: 'Delete listing',
                key: 'delete-listing',
              }
            case ProductStatus.PRODUCT_STATUS_LABRA_TESTING:
              return null
            default:
              return {
                ...option,
                disable: true,
                disabledTooltip: 'Coming Soon',
              }
          }
        }
        return option
      })
      .filter(option => option !== null) as ColumnMenuOption[]

  const selectedContent = ProductDetailTabs?.find(
    (tabContent, index) => index === activeTabIndex
  )?.renderElement

  const [open, setOpen] = useState<boolean>(false)
  const handleClose = () => {
    setOpen(false)
  }
  const handlePreview = () => {
    setOpen(true)
  }

  const handleErrorForPreview = (
    formikProps: FormikProps<FlyoutProductSections>
  ) => {
    const isCurrentPageHaveErr = validateProductCreationFlow(
      FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS,
      formikProps,
      true,
      true
    )

    return isCurrentPageHaveErr
  }

  const handleClickSubmit = async (
    formikProps: FormikProps<FlyoutProductSections>
  ) => {
    await formikProps.submitForm()
    const isCurrentPageHaveErr = await validateProductCreationFlow(
      getPageNameFromIndex(activeTabIndex),
      formikProps,
      true
    )
    if (!isCurrentPageHaveErr) {
      const findFirstErrPage = getFirstErrPage(formikProps)
      if (findFirstErrPage !== 4) {
        await setActiveTabIndex(findFirstErrPage)
        await formikProps.submitForm()
      } else {
        setOpenModal(true)
      }
    }
  }

  const callBackFlyoutProduct = () => {
    setDetailView(true)
  }

  const handleSubmitProduct = async (
    formikProps: FormikProps<FlyoutProductSections>
  ) => {
    setOpenModal(false)
    const productData = formikProps?.values
    if (currentAccountId) {
      await dispatch(
        updateFlyoutProduct({
          partnerId: currentAccountId,
          productForm: productData,
          productId,
          callBackFlyoutProduct,
        })
      )
    }
  }

  if (isEmpty(flyoutProductDetailForm)) {
    return <></>
  }

  return (
    <div data-testid={'view-product-listing'}>
      <div className={classes.headerContainer}>
        <div className={classes.appTitleHeading}>
          <div
            className={classes.appBackIcon}
            data-testid="back-button"
            onClick={() => navigate(-1)}
          >
            <FontAwesomeIcon icon={faArrowLeft} className={classes.backIcon} />
          </div>
          <Typography
            variant="h1"
            data-testid="heading"
            className={classes.appTitleHeadingText}
          >
            <ShortenedNameV2 name={productName} length={41}></ShortenedNameV2>
          </Typography>
        </div>
        <SelectedCloudIcon />
      </div>
      <div className={classes.root}>
        <Formik
          initialValues={flyoutProductDetailForm}
          validationSchema={FlyoutProductValidationSchema}
          validateOnMount={true}
          onSubmit={() => {}}
          enableReinitialize
        >
          {formikProps => {
            const { backgroundColor, content, subContent } =
              getStatusBarDetails({
                status,
                companyName: productName,
                auditJson,
              })
            const allValuesFilledForPreview = handleErrorForPreview(formikProps)
            const marketPlaceRedirect = (
              <div className={classes.publicUrl}>
                View your listing on AWS Marketplace
                <Link
                  target="_blank"
                  href={marketplaceUrl}
                  data-testid="cell-link"
                  className={classes.linkWrapper}
                >
                  <FontAwesomeIcon
                    icon={faArrowUpRightFromSquare}
                    className={classes.marketplaceLinkIcon}
                  />
                </Link>
              </div>
            )
            const subContentData = subContent ? (
              <div className={classes.subContentStatus}>{subContent}</div>
            ) : (
              ''
            )
            const subContentValue =
              status === 'Public' ? marketPlaceRedirect : subContentData

            const isHostWithLabra =
              formikProps?.values[
                FlyoutProductAddEditSectionName.GENERAL_INFORMATION
              ].hostWithLabra
            return (
              <Form
                style={{ width: '100%' }}
                className={!detailView ? classes.paddingBottom : ''}
              >
                <Grid container spacing={2}>
                  <Grid
                    className={classes.leftContainer}
                    size={{
                      sm: 12,
                      md: 9,
                      lg: 9,
                      xl: 10,
                    }}
                  >
                    {isChangeSetFailed && (
                      <div className={classes.failedStatus}>
                        <StatusBar
                          status={''}
                          backgroundColor={StatusBarColors.RED}
                          content={
                            'Request to update has been rejected by AWS Marketplace. Product information reverted to last successfull state.'
                          }
                          subContent={
                            failureErrorMessage ? (
                              <div
                                className={classes.errorSubContent}
                                data-testid={'failed-offer-content'}
                              >
                                <div className={classes.errorMsg}>
                                  Issues found: {failureErrorMessage}
                                </div>
                                <div className={classes.offerUpdatedAt}>
                                  {updatedAtValue}
                                </div>
                              </div>
                            ) : (
                              ''
                            )
                          }
                        />
                      </div>
                    )}
                    <BoxV2>
                      <StatusBar
                        status={status}
                        backgroundColor={backgroundColor}
                        content={
                          content ? (
                            <div className={classes.statusContent}>
                              {content}
                            </div>
                          ) : (
                            ''
                          )
                        }
                        subContent={subContentValue}
                      />
                      {!isEditEnable &&
                      !isChangeSetFailed &&
                      status !== 'AWS-testing' ? (
                        <div className={classes.editNote}>
                          <FontAwesomeIcon
                            icon={faHourglassStart}
                            className={classes.hourglassIcon}
                          />
                          <div className={classes.noteText}>
                            Your edit request is in progress, please check back
                            in 5 minutes.
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className={classes.subStatusContainer}>
                        <LabraToolTipV2
                          tooltipPlacement="bottom-start"
                          description={'Coming soon'}
                        >
                          <div className={classes.cloneContainer}>
                            <FontAwesomeIcon
                              icon={faClone}
                              className={classes.actionIcon}
                            />
                            <Typography
                              className={classes.subStatusHeadingContainer}
                            >
                              Clone this listing
                            </Typography>
                          </div>
                        </LabraToolTipV2>
                        {status === ProductStatus.PRODUCT_STATUS_AWS_TESTING ? (
                          <LabraToolTipV2
                            tooltipPlacement="bottom-start"
                            description={
                              'You cannot edit listing in AWS testing.'
                            }
                          >
                            <div
                              className={classes.editContainer}
                              onClick={handleEditClick}
                            >
                              <FontAwesomeIcon
                                icon={faPen}
                                className={classes.actionIcon}
                              />
                              <Typography
                                className={classes.subStatusHeadingContainer}
                              >
                                Edit listing
                              </Typography>
                            </div>
                          </LabraToolTipV2>
                        ) : (
                          <div
                            className={classes.editContainer}
                            onClick={handleEditClick}
                          >
                            <FontAwesomeIcon
                              icon={faPen}
                              className={classes.actionIcon}
                            />
                            <Typography
                              className={classes.subStatusHeadingContainer}
                            >
                              Edit listing
                            </Typography>
                          </div>
                        )}
                        {status !== ProductStatus.PRODUCT_STATUS_DRAFT &&
                          status !==
                            ProductStatus.PRODUCT_STATUS_CREATION_FAILED && (
                            <LabraToolTipV2
                              tooltipPlacement="bottom-start"
                              description={
                                isLoadingSyncWithCloud
                                  ? 'Sync is in progress.'
                                  : ''
                              }
                            >
                              <div
                                className={clsx(
                                  classes.editContainer,
                                  isLoadingSyncWithCloud
                                    ? classes.disabledBtn
                                    : ''
                                )}
                                onClick={handleProductSync}
                              >
                                <FontAwesomeIcon
                                  icon={faSync}
                                  className={classes.actionIcon}
                                />
                                <Typography
                                  className={classes.subStatusHeadingContainer}
                                  data-testid={'sync-with-aws'}
                                >
                                  Sync listing with AWS
                                </Typography>
                              </div>
                            </LabraToolTipV2>
                          )}
                        <div className={classes.moreContainer}>
                          <ColumnActionWithMenuV2
                            menuOptions={updateOptionsBasedOnStatus(status)}
                            handleSelectOption={handleSelectOption}
                            columnTitle={'More'}
                            toolTipPlacement={'bottom-start'}
                            iconColor={ColumnActionWithMenuColors.BLUE}
                          />
                        </div>
                      </div>
                    </BoxV2>
                    <ScrollToFieldError />
                    <div className={classes.mainTabContainer}>
                      <MainTabsV2
                        activeTabIndex={activeTabIndex}
                        onChange={index => setActiveTabIndex(index)}
                        tabs={ProductDetailTabs}
                      />
                      <div className={classes.mainTabContent}>
                        <div className={detailView ? classes.formDisabled : ''}>
                          {selectedContent}
                        </div>
                      </div>
                    </div>
                  </Grid>

                  {!isEmpty(auditJson) && (
                    <Grid
                      className={clsx(
                        classes.rightContainer,
                        classes.stickyStatusListing
                      )}
                      size={{
                        sm: 12,
                        md: 3,
                        lg: 3,
                        xl: 'grow',
                      }}
                    >
                      <StatusListing
                        statuses={
                          statuses?.filter(
                            i => i.display
                          ) as StatusListingItem[]
                        }
                        title={'Listing Status'}
                        titleIcon={faListCheck}
                      />
                    </Grid>
                  )}
                </Grid>
                {!detailView && (
                  <div>
                    <FooterV2
                      width={'calc(100% - 64px)'}
                      customClass={classes.rootFooter}
                      actions={
                        <>
                          {activeTabIndex === 2 && isHostWithLabra ? (
                            <BuyerRegistrationPreviewButton
                              allValuesFilledForPreview={
                                allValuesFilledForPreview
                              }
                              buyerRegistrationPagePreviewMessage={
                                buyerRegistrationPagePreviewMessage
                              }
                              handlePreview={handlePreview}
                            />
                          ) : (
                            <></>
                          )}
                          <div className={classes.submitButton}>
                            <ButtonV2
                              data-testid="submit-button"
                              styleType="primary"
                              onClick={() => handleClickSubmit(formikProps)}
                              loading={isLoading}
                            >
                              Submit
                            </ButtonV2>
                          </div>
                        </>
                      }
                    />
                  </div>
                )}
                <ModalConfirmV2
                  title={'Save changes?'}
                  description={
                    <Typography className={classes.modalText}>
                      <p className={classes.modalTextHeaderContainer}>
                        {' '}
                        Are you sure you want to save these changes?{' '}
                      </p>
                      <p>
                        Once you submit, a request will be sent to AWS to update
                        your listing with all edits that you have made.
                      </p>
                      <p>
                        These updates will be made to your listing only once AWS
                        team approves the request.
                      </p>
                      <p className={classes.modalTextNoteContainer}>
                        <span className={classes.nameBoldText}>Note: </span>
                        It may take a few minutes for your request to be
                        approved.
                      </p>
                    </Typography>
                  }
                  open={openModal}
                  onlyCloseModal={true}
                  onCloseModal={handleCloseModal}
                  titleAcceptButton={'Save'}
                  titleCancelButton={'Discard changes'}
                  onAccept={() => handleSubmitProduct(formikProps)}
                  onDecline={() => handleDiscardChanges(formikProps)}
                  variant={ModalSizeVariants.small}
                  icon={
                    <FontAwesomeIcon
                      icon={faSave}
                      className={classes.modalIcon}
                    />
                  }
                  hideCancelIcon={false}
                  hideCancelButton={false}
                />
                <ModalConfirmV2
                  title={'Unpublish listing?'}
                  description={
                    <Typography className={classes.modalText}>
                      <p> Are you sure you want to unpublish this listing?</p>
                      <p>
                        Once you unpublish, no new buyers will be able to see
                        your listing inside AWS marketplace as it will be
                        removed. Your current customers will continue paying you
                        till their purchase ends
                      </p>
                      <p>
                        You can choose to publish your listing back again at any
                        point in time
                      </p>
                      <p>
                        <span className={classes.nameBoldText}>Note: </span>
                        You can keep creating Private Offers on your unpublished
                        listings and sell your product.
                      </p>
                    </Typography>
                  }
                  open={openUnpublishModal}
                  titleAcceptButton={'Unpublish'}
                  onAccept={handleUnpublish}
                  onDecline={handleUnpublishDecline}
                  variant={ModalSizeVariants.small}
                  icon={
                    <FontAwesomeIcon
                      icon={faLaptopSlash}
                      className={classes.modalIcon}
                    />
                  }
                  hideCancelIcon={false}
                  hideCancelButton={false}
                />
                <ModalConfirmV2
                  title={'Publish listing?'}
                  description={
                    <Typography className={classes.modalText}>
                      <p> Are you sure you want to Publish this listing?</p>
                      <p>
                        Your listing is being tested by AWS Marketplace team and
                        it's important that any feedback provided by them has
                        been taken into account. If the changes asked by AWS
                        team are not made then your listing may be rejected.
                      </p>

                      <p>
                        <span className={classes.nameBoldText}>Note: </span>
                        Please ensure you work closely with the AWS team to give
                        them access to your product and aid them in the testing
                        process for quick approval.
                      </p>
                    </Typography>
                  }
                  open={openPublishModal}
                  titleAcceptButton={'Publish'}
                  onAccept={handlePublish}
                  onDecline={handlePublishDecline}
                  variant={ModalSizeVariants.small}
                  icon={
                    <FontAwesomeIcon
                      icon={faLaptop}
                      className={classes.modalIcon}
                    />
                  }
                  hideCancelIcon={false}
                  hideCancelButton={false}
                />
                <ModalConfirmV2
                  title={'Delete listing?'}
                  description={
                    <Typography className={classes.modalText}>
                      <p>
                        You will not be able to recover this listing or any
                        information inside it once your listing is deleted.
                      </p>
                      <p> Are you sure you want to delete this listing?</p>
                    </Typography>
                  }
                  open={openDeleteModal}
                  titleAcceptButton={'Delete'}
                  onAccept={handleDelete}
                  onDecline={handleDeleteDecline}
                  variant={ModalSizeVariants.small}
                  icon={
                    <FontAwesomeIcon
                      icon={faDeleteRight}
                      className={classes.modalIcon}
                    />
                  }
                  hideCancelIcon={false}
                  hideCancelButton={false}
                />
                <BuyerRegistrationPreviewModal
                  open={open}
                  handleClose={handleClose}
                />
                <SnackBar />
              </Form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

const getPageNameFromIndex = (index: number) => {
  switch (index) {
    case 0: {
      return FlyoutProductAddEditSectionName.GENERAL_INFORMATION
    }
    case 1: {
      return FlyoutProductAddEditSectionName.PRODUCT_DIMENSIONS
    }
    case 2: {
      return FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS
    }
    case 3: {
      return FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS
    }
    default: {
      return FlyoutProductAddEditSectionName.GENERAL_INFORMATION
    }
  }
}

const getFirstErrPage = (formikProps: FormikProps<FlyoutProductSections>) => {
  const productDetailPageErr = validateProductCreationFlow(
    FlyoutProductAddEditSectionName.GENERAL_INFORMATION,
    formikProps,
    true
  )
  const productDimensionPageErr = validateProductCreationFlow(
    FlyoutProductAddEditSectionName.PRODUCT_DIMENSIONS,
    formikProps,
    true
  )

  const landingPageErr = validateProductCreationFlow(
    FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS,
    formikProps,
    true
  )
  const notificationPageErr = validateProductCreationFlow(
    FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS,
    formikProps,
    true
  )

  if (productDetailPageErr) {
    return 0
  } else if (productDimensionPageErr) {
    return 1
  } else if (landingPageErr) {
    return 2
  } else if (notificationPageErr) {
    return 3
  } else {
    return 4
  }
}
